import ModalContext from 'contexts/ModalContext'
import React, { useCallback, useContext } from 'react'
import LuxPlusLabel from '../../../LuxKit/Label/LuxPlusLabel'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
import LuxPlusHiddenOfferModal from '../modals/LuxPlusHiddenOfferModal'

interface MappedProps {
  canViewLuxPlusBenefits: boolean
}
interface Props extends MappedProps {
  className?: string
}

function LuxPlusHiddenOfferLabel({ canViewLuxPlusBenefits }: Props) {
  const showModal = useContext(ModalContext)

  const toggleModal = useCallback(() => {
    showModal<boolean>(<LuxPlusHiddenOfferModal />)
  }, [showModal])

  return (
    <LuxPlusLabel type="member-only-offer" onClick={canViewLuxPlusBenefits ? undefined : toggleModal} />
  )
}

const mapStateToProps = (state: App.State): MappedProps => ({
  canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
})

export default connect(mapStateToProps)(LuxPlusHiddenOfferLabel)
